import { FC } from 'react'
import { IProps } from './types'
import { Content } from './CardBody.styled'

export const CardBody: FC<IProps> = ({ children, fullScreen }) => (
    <Content fullScreen={fullScreen}>{children}</Content>
)


